<div class="text-size-18 word-break page-container">
  <h1 class="mb-3 mt-5 text-size-40 fw-700">Privacy Policy</h1>
  <h3 class="mb-2 mt-5 text-size-30 fw-700">What Information Do We Collect?</h3>
  <p class="text-size-18 my-2">Effective Date: 17 April, 2024</p>
  <p class="text-size-18 my-2">
    Thank you for choosing to be part of our community. We are committed to protecting your personal information and your right to privacy.
    If you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please
    contact us at support@hifello.com.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">What Information Do We Collect?</h3>
  <p class="text-size-18 my-2">
    Information You Provide to Us: We collect personal information that you voluntarily provide to us when you register on the websites,
    participate in activities on the websites, or otherwise contact us.
  </p>
  <ul class="ul-disc">
    <ul>
      <li>
        <p class="text-size-18 my-2">
          Personal Information: Includes details such as name, email address, mailing address, phone number, and any other information you
          choose to provide.
        </p>
      </li>
      <li>
        <p class="text-size-18 my-2">
          Web Analytics: We collect data about how you interact with our websites, which includes the pages you visited and the links you
          clicked on.
        </p>
      </li>
    </ul>
  </ul>
  <h5 class="my-3 text-size-20 fw-700">Information Automatically Collected:</h5>
  <ul class="ul-disc">
    <ul>
      <li>
        <p class="text-size-18 my-2">
          Usage Details: When you access our websites, we automatically collect certain information about your device and usage of our
          websites, including information about your web browser, IP address, time zone, and some of the cookies installed on your device.
        </p>
      </li>
      <li>
        <p class="text-size-18 my-2">
          Web Analytics: We collect data about how you interact with our websites, which includes the pages you visited and the links you
          clicked on
        </p>
      </li>
    </ul>
  </ul>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Use of Cookies and Other Tracking Technologies</h3>
  <p class="text-size-18 my-2">
    We use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information
    about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Policy.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">How Do We Use Your Information?</h3>
  <p class="text-size-18 my-2">
    We use personal information collected via our websites for a variety of business purposes described below:
  </p>
  <ul class="ul-disc">
    <li>
      <p class="text-size-18 my-2">To Facilitate Account Creation and Logon Process.</p>
    </li>
    <li>
      <p class="text-size-18 my-2">
        To Send Administrative Information to You, for related details about your account, and the services we provide.
      </p>
    </li>
    <li>
      <p class="text-size-18 my-2">To Fulfill and Manage Your Orders in connection with the services you have chosen to use.</p>
    </li>
    <li>
      <p class="text-size-18 my-2">To Post Testimonials with your consent.</p>
    </li>
    <li>
      <p class="text-size-18 my-2">To Deliver Targeted Advertising to You based on your preferences and previous interactions.</p>
    </li>
    <li>
      <p class="text-size-18 my-2">
        For Business Transfers. We may use your information in connection with, or during negotiations of, any merger, sale of company
        assets, financing, or acquisition of all or a portion of our business to another company.
      </p>
    </li>
  </ul>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">How Do We Protect Your Information?</h3>
  <p class="text-size-18 my-2">
    We aim to protect your personal information through a system of organizational and technical security measures. We have implemented
    appropriate technical and organizational security measures designed to protect the security of any personal information we process.
    However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information
    storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other
    unauthorized third parties will not be able to defeat our security, and improperly collect, access, steal, or modify your information.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Third-Party Websites</h3>
  <p class="text-size-18 my-2">
    Our websites may contain links to third-party websites that are not operated by us. If you click on a third party link, you will be
    directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control
    over and assume no responsibility for the content, privacy policies, or practices of any third party sites or services.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Children's Privacy</h3>
  <p class="text-size-18 my-2">
    Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under
    13. If we become aware that we have collected personal information from a child under the age of 13, we will take steps to delete the
    information from our servers.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">California Residents</h3>
  <p class="text-size-18 my-2">
    If you are a resident of California, you are granted specific rights regarding access to your personal information.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Changes to This Privacy Policy</h3>
  <p class="text-size-18 my-2">
    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
    You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are
    posted on this page.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Contact Us</h3>
  <p class="text-size-18 my-2">If you have questions or comments about this policy, you may email us at support@hifello.com.</p>
</div>
